const Colors = {
  primary: '#001529',
  primaryAccent: '#1677FF',
  primaryAccentDark: '#1B76F4',
  secondary: '#FFFFFF',
};

export default Colors;